/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export const OccupancyType = {
  Occupied: 'Occupied',
  Reserved: 'Reserved',
} as const

export type OccupancyType = (typeof OccupancyType)[keyof typeof OccupancyType]
